export const ZONE_ENTITIES_INACTIVE_THRESHOLD = 60 * 1000; // 1 min
export const ZONE_ENTITIES_VALIDATE_INTERVAL = 1000 * 5; // 5s
export const TESTING_CLIENT_IDS = ['test-club', 'mmu-test', 'ict', 'firem', 'hans'];
export const IMPORT_CLIENT_IDS = ['ucl-som'];
export const ADMIN_CLIENT_IDS = ['admin'];
export const REAL_TIME_CLIENT_IDS = ['unifiid-demo', 'tsb', 'tasu', 'tds', 'test-club'];
export const FACE_CLIENT_IDS = ['thermal', '25ep', 'vava'];
export const LIVE_EVACUATION_CLIENT_IDS = ['test-club', 'acre'];
export const AWS_RESOURCES_ROOT =
	'https://s3.eu-west-2.amazonaws.com/unifi-id-res';



// WEBPACK FOOTER //
// ./src/config/constants.js